module.exports = __webpack_public_path__ + "media/images/common/pager-arrow-prev-a70da0b5ab7d2365221e249aa6160ebc.svg";